import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font: ${(props) => props.theme.fonts.h1InterNonBold};
  color: ${(props) => props.theme.colors.greys.darkest};
  padding-bottom: 8px;
`;

export const HeaderContainer = styled.div`
  flex: 0 0 auto;
  padding-bottom: 16px;
  border-bottom: 2px solid ${(props) => props.theme.colors.greys.light};
  position: relative;
`;

export const CloseButton = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  width: 24px;
  height: 24px;

  &:hover {
    opacity: 0.7;
  }
`;

export const ContentContainer = styled.div`
  flex: 1 1 auto;
  padding: 24px 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  border-top: 2px solid ${(props) => props.theme.colors.greys.light};
`;

export const TotalRatioContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;

  align-self: flex-end;
  align-items: center;
  padding: 16px 0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  column-gap: 24px;
`;
